import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const enTranslations = {
  // Navigation
  "nav.home": "Home",
  "nav.products": "Products",
  "nav.cart": "Cart",
  "nav.orders": "My Orders",
  "nav.wishlist": "Wishlist",
  "nav.contact": "Contact Us",
  "nav.profile": "Profile",
  "nav.signIn": "Sign In",
  "nav.logout": "Logout",
  "nav.searchPlaceholder": "Search products...",

  // Hero
  "hero.title": "VEEVAMMERCE STORE",
  "hero.subtitle": "Your First Choice for Best Products",
  "hero.cta": "Shop Now",

  // Categories
  "categories.title": "Shop by Category",
  "cat.digital-products": "Digital Products",
  "cat.ebooks": "E-Books",
  "cat.audiobooks": "Audiobooks",
  "cat.courses": "Digital Courses",
  "cat.food-products": "Food Products",
  "cat.mobile-accessories": "Mobile Accessories",
  "cat.medical": "Medical Products",
  "cat.cosmetics": "Beauty & Personal Care",
  "cat.beauty-personal-care": "Beauty & Personal Care",
  "cat.fashion": "Women's Fashion",
  "cat.kids-toys": "Kids Toys",
  "cat.pets-smart": "Pets Smart Products",
  "cat.home-decor": "Home Decoration",
  "cat.emergency": "Emergency Products",
  "cat.smart-products": "Smart Products",
  "cat.kitchen-smart-tools": "Kitchen Smart Tools",
  "cat.home-products": "Home Products",
  "cat.travel-products": "Travel Products",
  "cat.decoration": "Decoration Products",
  "cat.kids-products": "Kids Products",
  "cat.pet-products": "Pet Products",
  "cat.emergency-products": "Emergency Products",
  "cat.camping-products": "Camping Products",
  "cat.car-accessories": "Car Accessories",

  // Home Products subcategories
  "sub.cookware": "Cookware",
  "sub.bakeware": "Bakeware",
  "sub.kitchen-gadgets": "Kitchen Gadgets",
  "sub.kitchen-tools": "Kitchen Tools",
  "sub.food-storage": "Food Storage",
  "sub.drinkware": "Drinkware",
  "sub.home-appliances": "Home Appliances",
  "sub.cleaning-supplies": "Cleaning Supplies",
  "sub.bathroom-essentials": "Bathroom Essentials",
  "sub.bedroom-products": "Bedroom Products",
  "sub.home-organization": "Home Organization",
  "sub.home-fragrance": "Home Fragrance",
  "sub.smart-home": "Smart Home",
  // Travel Products subcategories
  "sub.travel-bags": "Travel Bags & Luggage",
  "sub.travel-accessories": "Travel Accessories",
  "sub.travel-organizers": "Travel Organizers",
  "sub.travel-electronics": "Travel Electronics",
  "sub.travel-safety": "Travel Safety",
  // Decoration subcategories
  "sub.wall-decor": "Wall Decor",
  "sub.decorative-lighting": "Decorative Lighting",
  "sub.decorative-accessories": "Decorative Accessories",
  "sub.candles-holders-d": "Candles & Holders",
  "sub.artificial-plants": "Artificial Plants",
  "sub.vases": "Vases",
  "sub.rugs-carpets-d": "Rugs & Carpets",
  "sub.curtains-blinds": "Curtains & Blinds",
  "sub.seasonal-decorations": "Seasonal Decorations",
  // Kids Products subcategories
  "sub.baby-essentials": "Baby Essentials",
  "sub.toys": "Toys",
  "sub.school-supplies": "School Supplies",
  "sub.kids-fashion": "Kids Fashion",
  "sub.nursery": "Nursery",
  "sub.baby-safety": "Baby Safety",
  "sub.baby-travel": "Baby Travel",
  // Pet Products subcategories
  "sub.dog-supplies": "Dog Supplies",
  "sub.cat-supplies": "Cat Supplies",
  "sub.pet-food": "Pet Food",
  "sub.pet-grooming": "Pet Grooming",
  "sub.pet-health": "Pet Health",
  "sub.aquarium-supplies": "Aquarium Supplies",
  "sub.bird-supplies": "Bird Supplies",
  "sub.small-animal-supplies": "Small Animal Supplies",
  // Emergency Products subcategories
  "sub.first-aid-emergency": "First Aid",
  "sub.emergency-lighting": "Emergency Lighting",
  "sub.emergency-power": "Emergency Power",
  "sub.survival-supplies": "Survival Supplies",
  "sub.fire-safety": "Fire Safety",
  "sub.rescue-equipment": "Rescue Equipment",
  // Camping subcategories
  "sub.tents": "Tents",
  "sub.sleeping-equipment": "Sleeping Equipment",
  "sub.camping-furniture": "Camping Furniture",
  "sub.outdoor-cooking": "Outdoor Cooking",
  "sub.camping-lighting": "Camping Lighting",
  "sub.hiking-equipment": "Hiking Equipment",
  "sub.water-hydration": "Water & Hydration",
  "sub.coolers": "Coolers",
  "sub.survival-equipment": "Survival Equipment",
  // Car Accessories subcategories
  "sub.car-interior": "Interior",
  "sub.car-exterior": "Exterior",
  "sub.car-electronics": "Electronics",
  "sub.car-cleaning": "Cleaning & Care",
  "sub.car-safety": "Safety",
  "sub.car-maintenance": "Maintenance",
  "sub.car-travel": "Travel",
  "sub.car-lighting": "Lighting",

  // Fashion section headers
  "sub.clothing": "Clothing",
  "sub.footwear": "Footwear",
  "sub.accessories": "Accessories",
  "sub.handbags": "Handbags",

  // Kids Toys Subcategories
  "sub.educational-toys": "Educational Toys",
  "sub.action-figures": "Action Figures",
  "sub.dolls": "Dolls & Accessories",
  "sub.building-blocks": "Building Blocks & LEGO",
  "sub.kids-puzzles": "Puzzles",
  "sub.outdoor-toys": "Outdoor Toys",
  "sub.board-games": "Board Games",
  "sub.plush-toys": "Plush Toys & Stuffed Animals",
  "sub.rc-toys": "Remote Control Toys",
  "sub.arts-crafts": "Arts & Crafts",
  "sub.baby-toys": "Baby & Toddler Toys",
  "sub.toy-vehicles": "Toy Cars & Vehicles",

  // E-Books Subcategories (alphabetical)
  "sub.ebooks": "E-Books",
  "sub.voicebooks": "Voice Books",
  "sub.excelSheets": "Excel Sheets",
  "sub.excel-sheets": "Excel Sheets & Templates",
  "sub.templates": "Templates",
  "sub.onlineCourses": "Online Courses",
  "sub.otherFormats": "Other Digital Formats",
  "sub.ai-learning": "AI Learning E-Books",
  "sub.business-marketing": "Business and Marketing E-Books",
  "sub.crossword-puzzles": "Crossword Puzzles",
  "sub.kids-ebooks": "Kids E-Books",
  "sub.medical-health": "Medical E-Books",
  "sub.puzzle-books": "Puzzle Books",
  "sub.relationships": "Relationships E-Books",
  "sub.self-development": "Self Development E-Books",
  "sub.wealth-building": "Money and Wealth Building E-Books",
  "sub.medical-health": "Medical and General Health E-Books",
  // Audio Books section
  "sub.audiobooksSection": "Audio Books",
  "sub.ai-learning-audio": "AI Learning Audio Books",
  "sub.business-marketing-audio": "Business and Marketing Audio Books",
  "sub.kids-audiobooks": "Kids Audio Books",
  "sub.medical-health-audio": "Medical and General Health Audio Books",
  "sub.relationships-audio": "Relationships Audio Books",
  "sub.self-development-audio": "Self Development Audio Books",
  "sub.wealth-building-audio": "Money and Wealth Building Audio Books",
  "sub.audiobooks": "Other Audio Books",
  "sub.courses": "Digital Courses",
  "sub.online-courses": "Online Courses",

  // Pets Smart Products
  "sub.smart-feeders": "Smart Pet Feeders",
  "sub.smart-water-fountains": "Smart Water Fountains",
  "sub.pet-cameras": "Pet Cameras & Monitors",
  "sub.gps-trackers": "GPS Pet Trackers",
  "sub.smart-collars": "Smart Collars & Tags",
  "sub.auto-litter-boxes": "Automatic Litter Boxes",
  "sub.smart-toys-pets": "Smart Pet Toys",
  "sub.pet-grooming-tools": "Smart Grooming Tools",
  "sub.pet-health-monitors": "Pet Health Monitors",
  "sub.smart-doors": "Smart Pet Doors",
  "sub.training-devices": "Training Devices & Clickers",
  "sub.aquarium-smart": "Smart Aquarium Tech",

  // Home Decoration
  "sub.wall-art": "Wall Art & Prints",
  "sub.mirrors": "Decorative Mirrors",
  "sub.vases-planters": "Vases & Planters",
  "sub.throw-pillows": "Throw Pillows & Cushions",
  "sub.rugs-carpets": "Rugs & Carpets",
  "sub.curtains-drapes": "Curtains & Drapes",
  "sub.candles-holders": "Candles & Holders",
  "sub.lamps-lighting": "Lamps & Decorative Lighting",
  "sub.clocks-decor": "Wall Clocks",
  "sub.table-decor": "Table Decor & Centerpieces",
  "sub.shelves-storage": "Decorative Shelves & Storage",
  "sub.artificial-flowers": "Artificial Flowers & Plants",
  "sub.sculptures-figurines": "Sculptures & Figurines",
  "sub.seasonal-decor": "Seasonal Decor",
  "sub.bathroom-decor": "Bathroom Decor",
  "sub.bedding-throws": "Bedding & Throws",

  // Food Products Subcategories
  "sub.ground-turkish-coffee": "Ground Turkish Coffee",
  "sub.dates": "Dates",
  "sub.original-honey": "Original Honey",

  // Food Products Subcategories
  "sub.ground-turkish-coffee": "Ground Turkish Coffee",
  "sub.flavored-coffee": "Flavored Coffee",
  "sub.specialty-coffee": "Specialty Coffee Beans",
  "sub.instant-coffee": "Instant Coffee",
  "sub.tea-collection": "Premium Tea Collection",
  "sub.dates": "Dates",
  "sub.original-honey": "Original Honey",
  "sub.olive-oil": "Premium Olive Oil",
  "sub.spices": "Authentic Spices",
  "sub.nuts-dried-fruits": "Nuts & Dried Fruits",

  // Kitchen Smart Tools Subcategories
  "sub.air-fryers": "Air Fryers",
  "sub.blenders": "Blenders & Mixers",
  "sub.coffee-makers": "Coffee & Espresso Makers",
  "sub.smart-kitchen-gadgets": "Smart Kitchen Gadgets",
  "sub.food-processors": "Food Processors",
  "sub.pressure-cookers": "Pressure & Slow Cookers",
  "sub.rice-cookers": "Rice Cookers & Steamers",
  "sub.toasters-ovens": "Toasters & Mini Ovens",
  "sub.juicers": "Juicers",
  "sub.kettles": "Electric Kettles",
  "sub.waffle-sandwich-makers": "Waffle & Sandwich Makers",
  "sub.knives-cutting-boards": "Knives & Cutting Boards",
  "sub.measuring-scales": "Measuring Scales & Spoons",
  "sub.cookware-pans": "Cookware & Pans",
  "sub.bakeware": "Bakeware",
  "sub.food-storage": "Food Storage & Vacuum Sealers",
  "sub.kitchen-organizers": "Kitchen Organizers",
  "sub.coffee-grinders": "Coffee Grinders",
  "sub.milk-frothers": "Milk Frothers",
  "sub.ice-cream-makers": "Ice Cream Makers",

  // Medical Subcategories
  "sub.medical-devices": "Medical Devices",
  "sub.health-monitors": "Health Monitors",
  "sub.therapy-equipment": "Therapy Equipment",
  "sub.first-aid": "First Aid",
  "sub.wellness-products": "Wellness Products",

  // Beauty & Personal Care Subcategories
  "sub.skincare": "Skincare",
  "sub.facial-cleansers": "Facial Cleansers",
  "sub.serums-treatments": "Serums & Treatments",
  "sub.moisturizers": "Moisturizers",
  "sub.sunscreens": "Sunscreens",
  "sub.anti-aging": "Anti-Aging",
  "sub.makeup": "Makeup",
  "sub.lip-care": "Lip Care & Lipsticks",
  "sub.eye-makeup": "Eye Makeup",
  "sub.nail-care": "Nail Care",
  "sub.hair-care": "Hair Care",
  "sub.shampoo-conditioner": "Shampoo & Conditioner",
  "sub.hair-styling": "Hair Styling Tools",
  "sub.hair-color": "Hair Color",
  "sub.grooming-tools": "Grooming Tools",
  "sub.electric-shavers": "Electric Shavers & Trimmers",
  "sub.fragrances": "Fragrances & Perfumes",
  "sub.bath-body": "Bath & Body",
  "sub.oral-care": "Oral & Dental Care",
  "sub.mens-grooming": "Men's Grooming",
  "sub.feminine-care": "Feminine Care",
  "sub.personal-hygiene": "Personal Hygiene",
  "sub.deodorants": "Deodorants",
  "sub.beauty-tools": "Beauty Tools & Accessories",

  // Emergency Subcategories
  "sub.solar-power": "Solar Power",
  "sub.emergency-kits": "Emergency Kits",
  "sub.survival-tools": "Survival Tools",
  "sub.portable-lights": "Portable Lights",

  // Mobile Accessories Subcategories
  "sub.phone-cases-covers": "Phone Cases & Covers",
  "sub.screen-protectors": "Screen Protectors",
  "sub.chargers-adapters": "Chargers & Adapters",
  "sub.power-banks": "Power Banks",
  "sub.charging-cables": "Charging Cables",
  "sub.wireless-chargers": "Wireless Chargers",
  "sub.earphones-headphones": "Earphones & Headphones",
  "sub.wireless-earbuds": "Wireless Earbuds",
  "sub.bluetooth-speakers": "Bluetooth Speakers",
  "sub.phone-holders-mounts": "Phone Holders & Mounts",
  "sub.car-accessories": "Car Mounts & Chargers",
  "sub.selfie-sticks-tripods": "Selfie Sticks & Tripods",
  "sub.ring-lights": "Ring Lights",
  "sub.smartwatch-accessories": "Smartwatch Accessories",
  "sub.cleaning-kits": "Cleaning Kits",
  "sub.lens-attachments": "Camera Lens Attachments",
  "sub.sim-cards-holders": "SIM Card Holders & Ejectors",
  "sub.otg-adapters": "OTG Adapters & Hubs",
  "sub.memory-cards": "Memory Cards & Readers",
  "sub.vr-headsets": "Mobile VR Headsets",
  "sub.gaming-controllers": "Mobile Gaming Controllers",
  "sub.stylus-pens": "Stylus Pens",
  "sub.pop-sockets": "Pop Sockets & Grips",

  // Women's Fashion Subcategories
  "sub.dresses": "Dresses",
  "sub.evening-gowns": "Evening Gowns",
  "sub.tops-tshirts": "Tops & T-Shirts",
  "sub.blouses-shirts": "Blouses & Shirts",
  "sub.sweaters-cardigans": "Sweaters & Cardigans",
  "sub.jeans-pants": "Jeans & Pants",
  "sub.leggings": "Leggings",
  "sub.shorts": "Shorts",
  "sub.skirts": "Skirts",
  "sub.jackets-coats": "Jackets & Coats",
  "sub.blazers": "Blazers & Suits",
  "sub.activewear-sportswear": "Activewear & Sportswear",
  "sub.loungewear": "Loungewear & Pajamas",
  "sub.swimwear": "Swimwear & Beachwear",
  "sub.lingerie": "Lingerie & Underwear",
  "sub.modest-wear": "Modest Wear & Abayas",
  "sub.hijab-scarves": "Hijabs & Scarves",
  "sub.traditional-wear": "Traditional & Ethnic Wear",
  "sub.shoes": "Shoes",
  "sub.heels": "Heels",
  "sub.flats-sandals": "Flats & Sandals",
  "sub.boots": "Boots",
  "sub.sneakers": "Sneakers",
  "sub.handbags-clutches": "Handbags & Clutches",
  "sub.backpacks": "Backpacks",
  "sub.wallets": "Wallets & Cardholders",
  "sub.jewelry": "Jewelry",
  "sub.necklaces": "Necklaces",
  "sub.earrings": "Earrings",
  "sub.rings": "Rings",
  "sub.bracelets": "Bracelets",
  "sub.watches": "Watches",
  "sub.sunglasses-eyewear": "Sunglasses & Eyewear",
  "sub.hair-accessories": "Hair Accessories",
  "sub.belts-scarves": "Belts & Fashion Scarves",
  "sub.hats-caps": "Hats & Caps",
  "sub.gloves": "Gloves",

  // Smart Products Subcategories
  "sub.smartwatches": "Smartwatches",
  "sub.fitness-trackers": "Fitness Trackers",
  "sub.smart-rings": "Smart Rings",
  "sub.smart-home-devices": "Smart Home Devices",
  "sub.smart-lights": "Smart Lights & Bulbs",
  "sub.smart-plugs": "Smart Plugs",
  "sub.smart-switches": "Smart Switches",
  "sub.smart-speakers": "Smart Speakers",
  "sub.smart-displays": "Smart Displays & Hubs",
  "sub.smart-security-systems": "Smart Security Systems",
  "sub.smart-cameras": "Smart Cameras & Doorbells",
  "sub.smart-appliances": "Smart Appliances",
  "sub.robot-vacuums": "Robot Vacuums & Mops",
  "sub.smart-thermostats": "Smart Thermostats",
  "sub.smart-locks": "Smart Locks",
  "sub.smart-kitchen-devices": "Smart Kitchen Devices",
  "sub.smart-wearables": "Smart Wearables",
  "sub.smart-health-devices": "Smart Health Devices",
  "sub.smart-scales": "Smart Scales",
  "sub.smart-air-purifiers": "Smart Air Purifiers",
  "sub.smart-humidifiers": "Smart Humidifiers",
  "sub.smart-fans": "Smart Fans",
  "sub.smart-pet-devices": "Smart Pet Devices",
  "sub.smart-baby-monitors": "Smart Baby Monitors",
  "sub.smart-garden": "Smart Garden Tech",
  "sub.vr-ar-devices": "VR & AR Devices",
  "sub.drones": "Drones",
  "sub.3d-printers": "3D Printers",
  "sub.smart-projectors": "Smart Projectors",

  // Digital Products Subcategories (top-level under Digital Products)
  "sub.ebooks": "E-Books",
  "sub.audiobooks": "Audiobooks",
  "sub.courses": "Digital Courses",

  // Product
  "product.addToCart": "Add to Cart",
  "product.inStock": "In stock",
  "product.available": "available",
  "product.digitalDownload": "Digital Download",
  "product.backToProducts": "Back to Products",

  // Cart
  "cart.empty": "Your cart is empty",
  "cart.checkout": "Proceed to Checkout",
  "cart.total": "Total",
  "cart.remove": "Remove",
  "cart.title": "Shopping Cart",
  "cart.subtotal": "Subtotal",
  "cart.quantity": "Quantity",
  "cart.continueShopping": "Continue Shopping",
  "cart.saveForLater": "Save for Later",
  "cart.savedItems": "Saved Items",
  "cart.moveToCart": "Move to Cart",

  // Checkout
  "checkout.title": "Checkout",
  "checkout.orderSummary": "Order Summary",
  "checkout.shippingInfo": "Shipping Information",
  "checkout.paymentMethod": "Payment Method",
  "checkout.placeOrder": "Place Order",
  "checkout.processing": "Processing...",
  "checkout.couponCode": "Coupon Code",
  "checkout.applyCoupon": "Apply",
  "checkout.giftCard": "Gift Card",
  "checkout.checkBalance": "Check Balance",
  "checkout.applyGiftCard": "Apply Gift Card",
  "checkout.guestCheckout": "Guest Checkout",
  "checkout.name": "Full Name",
  "checkout.email": "Email Address",
  "checkout.phone": "Phone Number",
  "checkout.street": "Street Address",
  "checkout.city": "City",
  "checkout.state": "State/Province",
  "checkout.zip": "ZIP/Postal Code",
  "checkout.country": "Country",
  "checkout.discount": "Discount",
  "checkout.total": "Total",
  "checkout.payWithStripe": "Pay with Stripe",

  // Orders
  "order.success": "Order Placed Successfully",
  "order.download": "Download",
  "order.noOrders": "No orders yet",
  "order.startShopping": "Start shopping",
  "order.total": "Order Total",
  "order.items": "Items",
  "order.status.confirmed": "Confirmed",
  "order.status.processing": "Processing",
  "order.status.shipped": "Shipped",
  "order.status.delivered": "Delivered",

  // Wishlist
  "wishlist.title": "My Wishlist",
  "wishlist.empty": "Your wishlist is empty",
  "wishlist.browseProducts": "Browse products",
  "wishlist.signInPrompt": "Sign in to view your wishlist",
  "wishlist.addedToast": "Added to wishlist",
  "wishlist.removedToast": "Removed from wishlist",

  // Reviews
  "reviews.title": "Reviews",
  "reviews.writeReview": "Write a Review",
  "reviews.rating": "Rating",
  "reviews.comment": "Comment",
  "reviews.commentPlaceholder": "Share your experience...",
  "reviews.submit": "Submit Review",
  "reviews.submitting": "Submitting...",
  "reviews.noReviews": "No reviews yet. Be the first to review!",
  "reviews.alreadyReviewed": "You have already reviewed this product",

  // Filters
  "filters.title": "Filters",
  "filters.subcategory": "Subcategory",
  "filters.minRating": "Minimum Rating",
  "filters.priceRange": "Price Range",
  "filters.clearAll": "Clear all",
  "filters.showing": "Showing",
  "filters.of": "of",
  "filters.products": "products",
  "filters.filtersActive": "filter(s) active",
  "filters.noProducts": "No products found",
  "filters.preferredLanguage": "Preferred Language",
  "filters.allLanguages": "All languages",
  "filters.noEbookLanguages": "No e-book languages available yet.",
  "filters.clearAndTry": "Clear filters and try again",
  "filters.searchPlaceholder": "Search products by name, brand, or SKU...",

  // Admin
  "admin.title": "Admin - Add Product",
  "admin.productName": "Product Name",
  "admin.description": "Description",
  "admin.price": "Price ($)",
  "admin.stock": "Stock",
  "admin.category": "Category",
  "admin.subcategory": "Subcategory",
  "admin.selectSubcategory": "Select subcategory",
  "admin.productType": "Product Type",
  "admin.physical": "Physical Product",
  "admin.ebook": "E-book",
  "admin.productImage": "Product Image",
  "admin.uploadImage": "Upload Image",
  "admin.ebookFile": "E-book PDF File",
  "admin.uploadPdf": "Upload PDF",
  "admin.createProduct": "Create Product",
  "admin.uploading": "Uploading...",

  // Auth
  "auth.signIn": "Sign In",
  "auth.signingIn": "Signing In...",
  "auth.register": "Register",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.confirmPassword": "Confirm Password",
  "auth.name": "Full Name",
  "auth.phone": "Phone Number",
  "auth.noAccount": "Don't have an account?",
  "auth.haveAccount": "Already have an account?",
  "auth.welcomeBack": "Welcome Back",
  "auth.signInSubtitle": "Sign in to your account to continue",
  "auth.createAccount": "Create Account",
  "auth.creatingAccount": "Creating Account...",
  "auth.joinUs": "Join us and start shopping",
  "auth.loginSuccess": "Welcome back!",
  "auth.invalidCredentials": "Invalid email or password",
  "auth.registerSuccess": "Account created successfully!",
  "auth.registerFailed": "Registration failed",
  "auth.passwordMismatch": "Passwords do not match",
  "auth.passwordTooShort": "Password must be at least 6 characters",

  // Brand
  "brand.name": "VEEVAMMERCE",
  "brand.store": "STORE",
  "brand.tagline": "Your First Choice for Best Products",

  // Navigation
  "nav.about": "About Us",

  // General
  "general.loading": "Loading...",
  "general.all": "All",
  "general.apply": "Apply",
  "general.viewAll": "View All",
  "general.allProducts": "All Products",
  "general.prev": "Prev",
  "general.next": "Next",
  "general.delete": "Delete",
  "general.confirm": "Confirm",
  "general.cancel": "Cancel",

  // Cart extra
  "cart.couponCode": "Coupon Code",
  "cart.couponDiscount": "Coupon Discount",
  "cart.applying": "Applying...",

  // Checkout extra
  "checkout.applying": "Applying...",
  "checkout.checking": "Checking...",
  "checkout.pay": "Pay",

  // Register extra
  "auth.verifyEmail": "Verify Your Email",
  "auth.verifySubtitle": "Enter the 6-digit code sent to",
  "auth.verificationCode": "Verification Code",
  "auth.verifyBtn": "Verify & Create Account",
  "auth.verifying": "Verifying...",
  "auth.otpSent": "Verification code sent to your email!",
  "auth.checkSpam": "Didn't receive the code? Check your spam folder.",
  "auth.addAddress": "Add shipping address (optional)",
  "auth.hideAddress": "Hide shipping address",
  "auth.address": "Address",
  "auth.street": "Street",
  "auth.city": "City",
  "auth.state": "State",
  "auth.zip": "ZIP Code",
  "auth.country": "Country",

  // Orders extra
  "order.myOrders": "My Orders",
  "order.orderNumber": "Order",
  "order.date": "Date",
  "order.trackOrder": "Track Order",

  // Product extra
  "product.description": "Description",
  "product.reviews": "Reviews",
  "product.relatedProducts": "Related Products",
  "product.color": "Color",
  "product.size": "Size",
  "product.material": "Material",
  "product.weight": "Weight",
  "product.freeShipping": "Free Shipping",
  "product.ebookLanguage": "Language",
  "product.otherLanguages": "E-Books in Other Languages",

  // Profile
  "profile.title": "My Profile",
  "profile.editProfile": "Edit Profile",
  "profile.addresses": "Addresses",
  "profile.addAddress": "Add Address",

  // Terms
  "footer.terms": "Terms & Policy",

  // Chat
  "chat.title": "VEEVAMMERCE Support",
  "chat.subtitle": "AI Assistant - Always Online",
  "chat.welcome": "Hi! Welcome to VEEVAMMERCE Support. How can I help you today?",
  "chat.placeholder": "Type your message...",

  // Language names
  "lang.english": "English",
  "lang.arabic": "Arabic",
  "lang.french": "French",
  "lang.turkish": "Turkish",
  "lang.german": "German",
  "lang.italian": "Italian",
  "lang.chinese": "Chinese",
  "lang.hindi": "Hindi",

  // Affiliate program
  "aff.becomeAffiliate": "Become an Affiliate",
  "aff.applyNow": "Apply now",
  "aff.signIn": "Sign in",
  "aff.signingIn": "Signing in…",
  "aff.register.title": "Become a VEEVAMMERCE Affiliate",
  "aff.register.subtitle": "Earn commission on every sale you refer. Get a unique referral link, a discount code for your audience, and a dashboard to track your earnings.",
  "aff.login.title": "Affiliate Sign In",
  "aff.login.subtitle": "Access your earnings dashboard.",
  "aff.notAffiliateYet": "Not an affiliate yet?",
  "aff.alreadyAffiliate": "Already an affiliate?",
  "aff.field.firstName": "First Name",
  "aff.field.lastName": "Last Name",
  "aff.field.company": "Company Name (optional)",
  "aff.field.website": "Website Address",
  "aff.field.websiteHint": "Required if no social media URL is provided.",
  "aff.field.email": "Email Address",
  "aff.field.phone": "Phone Number",
  "aff.field.country": "Country of Residence",
  "aff.field.city": "City",
  "aff.field.nationality": "Nationality",
  "aff.field.nationalityPh": "e.g. Egyptian, American",
  "aff.field.social": "Social Media URL",
  "aff.field.socialHint": "Required if no website URL is provided. Instagram / TikTok / YouTube / X.",
  "aff.field.languages": "Languages You Speak",
  "aff.field.langSearch": "Search languages…",
  "aff.field.certificates": "Certificates & Qualifications",
  "aff.field.certificatesHint": "List your relevant certifications, degrees, or completed courses.",
  "aff.field.certificatesPh": "HubSpot Inbound, MBA, Google Ads, etc.",
  "aff.field.skills": "Skills",
  "aff.field.skillSearch": "Search skills…",
  "aff.field.idDocument": "ID / Passport Copy",
  "aff.field.idHint": "JPG, PNG, or PDF. Max 8 MB. Used for identity verification.",
  "aff.field.uploadId": "Upload ID/Passport",
  "aff.field.replaceFile": "Replace file",
  "aff.field.uploading": "Uploading…",
  "aff.field.docUploaded": "Document uploaded ✓",
  "aff.field.password": "Password",
  "aff.field.passwordHint": "At least 8 characters with letters and numbers.",
  "aff.terms": "By applying, you agree to the VEEVAMMERCE Affiliate Terms.",
  "aff.submit": "Submit Application",
  "aff.submitting": "Submitting…",
  "aff.toast.received": "Application received — we'll review and email you within 1–2 business days.",
  "aff.toast.welcomeBack": "Welcome back!",
  "aff.toast.loginFailed": "Login failed.",
  "aff.toast.registerFailed": "Registration failed. Please try again.",
  "aff.toast.needWebOrSocial": "Please provide either a website OR a social media page URL",
  "aff.toast.needCertificates": "Please list your certificates and qualifications",
  "aff.toast.needLanguage": "Please select at least one language you speak",
  "aff.toast.needId": "Please upload a copy of your ID or passport",
  "aff.toast.fileTooLarge": "File too large — max 8 MB",
  "aff.toast.uploadFailed": "Upload failed. Please try a smaller file or different format.",
  "aff.toast.idUploaded": "ID document uploaded",

  // Affiliate dashboard
  "aff.dash.welcome": "Welcome",
  "aff.dash.subtitle": "Your affiliate dashboard — track clicks, sales, and earnings.",
  "aff.dash.signOut": "Sign out",
  "aff.dash.referralCode": "Your Referral Code",
  "aff.dash.referralCodeHint": "Share this code — customers get 10% off, you earn {pct}% commission.",
  "aff.dash.referralLink": "Your Referral Link",
  "aff.dash.referralLinkHint": "Every click + sale through this link is attributed to you.",
  "aff.dash.copied": "Copied!",
  "aff.dash.clicks": "Clicks",
  "aff.dash.sales": "Sales",
  "aff.dash.totalEarnings": "Total Earnings",
  "aff.dash.conversion": "Conversion",
  "aff.dash.pendingEarnings": "Pending Earnings",
  "aff.dash.paidOut": "Paid Out",
  "aff.dash.revenueDriven": "Revenue Driven",
  "aff.dash.clickAnalytics": "Click Analytics",
  "aff.dash.lastDaysClicks": "Last {days} days · {count} total clicks",
  "aff.dash.topLanding": "Top Landing Pages",
  "aff.dash.noLandingData": "No landing data yet.",
  "aff.dash.devices": "Devices",
  "aff.dash.payoutMethod": "Payout Method",
  "aff.dash.payoutMethodHint": "Choose how you want to receive your monthly commission payouts.",
  "aff.dash.payout.paypal": "PayPal",
  "aff.dash.payout.iban": "Bank Transfer (IBAN)",
  "aff.dash.payout.manual": "Manual / Other",
  "aff.dash.payoutPaypalEmail": "PayPal Email",
  "aff.dash.payoutIban": "IBAN",
  "aff.dash.payoutHolder": "Account Holder",
  "aff.dash.payoutBank": "Bank Name (optional)",
  "aff.dash.commissionRate": "Effective commission rate:",
  "aff.dash.manualOverride": "(manual override)",
  "aff.dash.tierBased": "(tier-based)",
  "aff.dash.savePayout": "Save Method",
  "aff.dash.saving": "Saving…",
  "aff.dash.recentSales": "Recent Sales",
  "aff.dash.noSales": "No sales yet — share your code and link to start earning.",
  "aff.dash.tbl.date": "Date",
  "aff.dash.tbl.order": "Order",
  "aff.dash.tbl.subtotal": "Subtotal",
  "aff.dash.tbl.commission": "Commission",
  "aff.dash.tbl.source": "Source",
  "aff.dash.tbl.status": "Status",
  "aff.dash.payoutHistory": "Payout History",
  "aff.dash.noPayouts": "Payouts run monthly. You'll see them here once issued.",
  "aff.dash.toast.choosePayout": "Choose a payout method",
  "aff.dash.toast.paypalRequired": "PayPal email is required",
  "aff.dash.toast.ibanRequired": "IBAN and Account Holder are required",
  "aff.dash.toast.saved": "Payout method saved",
  "aff.dash.toast.saveFailed": "Failed to save payout method",
  "aff.dash.toast.signInRequired": "Please sign in to view your dashboard",

  // Chart polish
  "aff.chart.totalClicks": "Total",
  "aff.chart.avgPerDay": "Avg / day",
  "aff.chart.peakDay": "Peak day",
  "aff.dash.noDeviceData": "No device data yet.",

  // Announcement bar / promo banners
  "ann.discount": "30% OFF",
  "ann.for100": "for the first 100 customers — ",
  "ann.spotsLeft": "only {count} spots left!",
  "ann.registerToday": "register today!",

  // Nav
  "nav.admin": "Admin",
  "nav.categories": "Categories",

  // Categories — mega menu helpers
  "categories.viewAllInCat": "View all →",
  "categories.noSubs": "No subcategories yet.",

  // Footer
  "footer.tagline": "Your First Choice for Best Products",
  "footer.quickLinks": "Quick Links",
  "footer.contactUs": "Contact Us",
  "footer.rights": "All rights reserved.",

  // Contact
  "contact.title": "Contact Us",
  "contact.subtitle": "We'd love to hear from you. Send us a message and we'll get back to you.",
  "contact.info": "Get in Touch",
  "contact.emailLabel": "Email",
  "contact.location": "Location",
  "contact.firstName": "First Name",
  "contact.firstNamePlaceholder": "John",
  "contact.lastName": "Last Name",
  "contact.lastNamePlaceholder": "Doe",
  "contact.emailField": "Email",
  "contact.message": "Message",
  "contact.messagePlaceholder": "How can we help you?",
  "contact.send": "Send Message",
  "contact.sending": "Sending...",
  "contact.success": "Message sent successfully!",
  "contact.error": "Failed to send message. Please try again.",
  "contact.thankYou": "Thank You!",
  "contact.thankYouMessage": "We've received your message and will get back to you soon.",
  "contact.sendAnother": "Send another message",
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslations },
      ar: { translation: {
        "brand.name": "VEEVAMMERCE",
        "brand.store": "متجر",
        "brand.tagline": "خيارك الأول لأفضل المنتجات",

        "nav.home": "الرئيسية",
        "nav.products": "المنتجات",
        "nav.contact": "اتصل بنا",
        "nav.cart": "سلة التسوق",
        "nav.wishlist": "المفضلة",
        "nav.orders": "الطلبات",
        "nav.profile": "الملف الشخصي",
        "nav.signIn": "تسجيل الدخول",
        "nav.signOut": "تسجيل الخروج",
        "nav.admin": "لوحة التحكم",
        "nav.search": "بحث عن المنتجات...",

        "hero.title": "متجر VEEVAMMERCE",
        "hero.subtitle": "خيارك الأول لأفضل المنتجات",
        "hero.cta": "تسوق الآن",

        "categories.title": "تسوق حسب الفئة",
        "cat.digital-products": "المنتجات الرقمية",
        "cat.ebooks": "كتب إلكترونية",
        "cat.audiobooks": "كتب صوتية",
        "cat.courses": "دورات رقمية",
        "cat.food-products": "منتجات غذائية",
        "cat.mobile-accessories": "إكسسوارات الهاتف",
        "cat.medical": "منتجات طبية",
        "cat.cosmetics": "الجمال والعناية الشخصية",
        "cat.beauty-personal-care": "الجمال والعناية الشخصية",
        "cat.fashion": "أزياء نسائية",
        "cat.emergency": "منتجات الطوارئ",
        "cat.smart-products": "منتجات ذكية",
        "cat.kitchen-smart-tools": "أدوات المطبخ الذكية",

        "nav.about": "من نحن",

        "about.title": "عن VEEVAMMERCE",
        "about.subtitle": "شريكك الموثوق في التجارة الإلكترونية العالمية",
        "about.whoWeAre": "من نحن",
        "about.para1": "VEEVAMMERCE LLC هي أكثر من مجرد شركة تجارة إلكترونية — إنها بوابة عالمية لتجارة رقمية أذكى وأسرع وأكثر اتصالاً.",
        "about.para2": "مسجلة في ولاية وايومنغ المعروفة بدعمها للابتكار، تم تأسيسنا برؤية واضحة: جعل التسوق عبر الإنترنت أبسط وأسهل في أي مكان في العالم بلا حدود.",
        "about.para3": "في VEEVAMMERCE، نمزج بين التكنولوجيا المتطورة والرؤية السوقية العميقة لإنشاء تجارب تسوق سلسة ومنصات قابلة للتوسع واستراتيجيات نمو مبنية على البيانات. سواء كنت تطلق علامة تجارية جديدة أو توسع علامة قائمة، نحوّل الأفكار إلى أعمال عالمية مزدهرة.",
        "about.para4": "مهمتنا بسيطة — تجاوز الحدود، فتح الفرص، وإعادة تعريف ما هو ممكن في التجارة الإلكترونية.",
        "about.para5": "نحن شركة تجارة إلكترونية عالمية مسجلة في ولاية وايومنغ، الولايات المتحدة الأمريكية. نعتمد على ثقة عملائنا حول العالم كأساس لنجاحنا.",
        "about.globalTitle": "انتشار عالمي",
        "about.globalDesc": "أكثر من 20 لغة، 55+ عملة، شحن عالمي من عملياتنا في الولايات المتحدة.",
        "about.trustTitle": "موثوق وآمن",
        "about.trustDesc": "مسجلة رسمياً في وايومنغ، الولايات المتحدة. مدفوعات آمنة عبر Stripe مع حماية كاملة للمشتري.",
        "about.shippingTitle": "توصيل سريع",
        "about.shippingDesc": "شركاء شحن موثوقون يضمنون وصول طلباتك بسرعة وأمان إلى باب منزلك.",
        "about.supportTitle": "دعم بالذكاء الاصطناعي",
        "about.supportDesc": "روبوت دردشة ذكي متاح على مدار الساعة لمساعدتك في الطلبات والمنتجات وأي استفسارات.",

        "sub.wealth-building": "كتب بناء الثروة",
        "sub.business-marketing": "كتب الأعمال والتسويق",
        "sub.ai-learning": "كتب تعلم الذكاء الاصطناعي",
        "sub.medical-health": "كتب الصحة العامة والطب",
        "sub.self-development": "كتب تطوير الذات",
        "sub.relationships": "كتب العلاقات",
        "sub.ground-turkish-coffee": "قهوة تركية مطحونة",
        "sub.dates": "تمور",
        "sub.original-honey": "عسل أصلي",
        "sub.air-fryers": "مقالي هوائية",
        "sub.blenders": "خلاطات وعصارات",
        "sub.coffee-makers": "آلات القهوة والإسبريسو",
        "sub.smart-kitchen-gadgets": "أدوات مطبخ ذكية",
        "sub.medical-devices": "أجهزة طبية",
        "sub.health-monitors": "أجهزة مراقبة الصحة",
        "sub.therapy-equipment": "معدات العلاج",
        "sub.first-aid": "إسعافات أولية",
        "sub.wellness-products": "منتجات العافية",
        "sub.skincare": "العناية بالبشرة",
        "sub.makeup": "مكياج",
        "sub.hair-care": "العناية بالشعر",
        "sub.grooming-tools": "أدوات العناية الشخصية",
        "sub.fragrances": "عطور",
        "sub.solar-power": "الطاقة الشمسية",
        "sub.emergency-kits": "مجموعات الطوارئ",
        "sub.survival-tools": "أدوات البقاء",
        "sub.portable-lights": "إضاءة محمولة",

        "product.addToCart": "أضف إلى السلة",
        "product.addedToCart": "تمت الإضافة إلى السلة",
        "product.inStock": "متوفر",
        "product.available": "متاح",
        "product.outOfStock": "غير متوفر",
        "product.digitalDownload": "تحميل رقمي",
        "product.backToProducts": "العودة إلى المنتجات",
        "product.description": "الوصف",
        "product.reviews": "التقييمات",
        "product.color": "اللون",
        "product.size": "المقاس",
        "product.material": "المادة",
        "product.weight": "الوزن",
        "product.freeShipping": "شحن مجاني",
        "product.ebookLanguage": "اللغة",
        "product.otherLanguages": "كتب إلكترونية بلغات أخرى",

        "cart.empty": "سلة التسوق فارغة",
        "cart.checkout": "متابعة الدفع",
        "cart.total": "المجموع",
        "cart.remove": "إزالة",
        "cart.title": "سلة التسوق",
        "cart.subtotal": "المجموع الفرعي",
        "cart.quantity": "الكمية",
        "cart.continueShopping": "متابعة التسوق",
        "cart.saveForLater": "حفظ لوقت لاحق",
        "cart.savedItems": "العناصر المحفوظة",
        "cart.moveToCart": "نقل إلى السلة",
        "cart.couponCode": "رمز القسيمة",
        "cart.couponDiscount": "خصم القسيمة",

        "checkout.title": "إتمام الشراء",
        "checkout.orderSummary": "ملخص الطلب",
        "checkout.shippingInfo": "معلومات الشحن",
        "checkout.paymentMethod": "طريقة الدفع",
        "checkout.placeOrder": "إتمام الطلب",
        "checkout.processing": "جاري المعالجة...",
        "checkout.couponCode": "رمز القسيمة",
        "checkout.applyCoupon": "تطبيق",
        "checkout.giftCard": "بطاقة هدية",
        "checkout.checkBalance": "التحقق من الرصيد",
        "checkout.applyGiftCard": "تطبيق بطاقة الهدية",
        "checkout.guestCheckout": "الشراء كضيف",
        "checkout.name": "الاسم الكامل",
        "checkout.email": "البريد الإلكتروني",
        "checkout.phone": "رقم الهاتف",
        "checkout.street": "العنوان",
        "checkout.city": "المدينة",
        "checkout.state": "المنطقة / المحافظة",
        "checkout.zip": "الرمز البريدي",
        "checkout.country": "الدولة",
        "checkout.discount": "الخصم",
        "checkout.total": "المجموع",
        "checkout.payWithStripe": "الدفع عبر Stripe",
        "checkout.applying": "جاري التطبيق...",
        "checkout.checking": "جاري التحقق...",
        "checkout.pay": "ادفع",

        "order.success": "تم تقديم الطلب بنجاح",
        "order.download": "تحميل",
        "order.noOrders": "لا توجد طلبات بعد",
        "order.startShopping": "ابدأ التسوق",
        "order.total": "إجمالي الطلب",
        "order.items": "العناصر",
        "order.status.confirmed": "مؤكد",
        "order.status.processing": "قيد المعالجة",
        "order.status.shipped": "تم الشحن",
        "order.status.delivered": "تم التسليم",

        "wishlist.title": "قائمة المفضلة",
        "wishlist.empty": "قائمة المفضلة فارغة",
        "wishlist.browseProducts": "تصفح المنتجات",

        "reviews.title": "التقييمات",
        "reviews.writeReview": "اكتب تقييماً",
        "reviews.rating": "التقييم",
        "reviews.comment": "التعليق",
        "reviews.commentPlaceholder": "شاركنا تجربتك...",
        "reviews.submit": "إرسال التقييم",
        "reviews.submitting": "جاري الإرسال...",
        "reviews.noReviews": "لا توجد تقييمات بعد. كن أول من يقيّم!",

        "filters.title": "التصفية",
        "filters.subcategory": "الفئة الفرعية",
        "filters.minRating": "الحد الأدنى للتقييم",
        "filters.priceRange": "نطاق السعر",
        "filters.clearAll": "مسح الكل",
        "filters.showing": "عرض",
        "filters.of": "من",
        "filters.products": "منتجات",
        "filters.noProducts": "لم يتم العثور على منتجات",
        "filters.clearAndTry": "امسح التصفية وحاول مرة أخرى",
        "filters.searchPlaceholder": "ابحث عن المنتجات بالاسم أو العلامة التجارية...",

        "auth.signIn": "تسجيل الدخول",
        "auth.signingIn": "جاري تسجيل الدخول...",
        "auth.register": "إنشاء حساب",
        "auth.email": "البريد الإلكتروني",
        "auth.password": "كلمة المرور",
        "auth.confirmPassword": "تأكيد كلمة المرور",
        "auth.name": "الاسم الكامل",
        "auth.phone": "رقم الهاتف",
        "auth.noAccount": "ليس لديك حساب؟",
        "auth.haveAccount": "لديك حساب بالفعل؟",
        "auth.welcomeBack": "مرحباً بعودتك",
        "auth.signInSubtitle": "سجّل الدخول إلى حسابك للمتابعة",
        "auth.createAccount": "إنشاء حساب",
        "auth.creatingAccount": "جاري إنشاء الحساب...",
        "auth.joinUs": "انضم إلينا وابدأ التسوق",
        "auth.loginSuccess": "مرحباً بعودتك!",
        "auth.invalidCredentials": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
        "auth.registerSuccess": "تم إنشاء الحساب بنجاح!",
        "auth.registerFailed": "فشل التسجيل",
        "auth.passwordMismatch": "كلمتا المرور غير متطابقتين",
        "auth.passwordTooShort": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
        "auth.forgotPassword": "نسيت كلمة المرور؟",
        "auth.verifyEmail": "تحقق من بريدك الإلكتروني",
        "auth.verifySubtitle": "أدخل الرمز المكون من 6 أرقام المرسل إلى",
        "auth.verificationCode": "رمز التحقق",
        "auth.verifyBtn": "تحقق وأنشئ الحساب",
        "auth.verifying": "جاري التحقق...",
        "auth.checkSpam": "لم تستلم الرمز؟ تحقق من مجلد البريد العشوائي.",
        "auth.addAddress": "إضافة عنوان الشحن (اختياري)",
        "auth.hideAddress": "إخفاء عنوان الشحن",

        "general.loading": "جاري التحميل...",
        "general.all": "الكل",
        "general.apply": "تطبيق",
        "general.viewAll": "عرض الكل",
        "general.allProducts": "جميع المنتجات",

        "footer.tagline": "خيارك الأول لأفضل المنتجات",
        "footer.quickLinks": "روابط سريعة",
        "footer.contactUs": "اتصل بنا",
        "footer.rights": "جميع الحقوق محفوظة.",
        "footer.terms": "الشروط والسياسة",

        "contact.title": "اتصل بنا",
        "contact.subtitle": "نحب أن نسمع منك. أرسل لنا رسالة وسنعود إليك.",
        "contact.info": "تواصل معنا",
        "contact.emailLabel": "البريد الإلكتروني",
        "contact.location": "الموقع",
        "contact.firstName": "الاسم الأول",
        "contact.lastName": "اسم العائلة",
        "contact.emailField": "البريد الإلكتروني",
        "contact.message": "الرسالة",
        "contact.messagePlaceholder": "كيف يمكننا مساعدتك؟",
        "contact.send": "إرسال الرسالة",
        "contact.sending": "جاري الإرسال...",
        "contact.success": "تم إرسال الرسالة بنجاح!",
        "contact.thankYou": "شكراً لك!",
        "contact.sendAnother": "إرسال رسالة أخرى",

        "terms.title": "الشروط والسياسة",
        "terms.subtitle": "يرجى قراءة الشروط والسياسات بعناية قبل إجراء أي عملية شراء.",
        "terms.digitalTitle": "١- المنتجات الرقمية (الكتب الإلكترونية) - لا استرداد",
        "terms.digitalPolicy": "جميع المنتجات الرقمية، بما في ذلك الكتب الإلكترونية، غير قابلة للاسترداد. نظراً لطبيعة المحتوى الرقمي، بمجرد إتمام عملية الشراء وتوفير رابط التحميل، لن يتم إصدار أي استرداد تحت أي ظرف.",
        "terms.digitalNote": "لا استرداد للمنتجات الرقمية. جميع المبيعات نهائية.",
        "terms.physicalTitle": "٢- المنتجات المادية - سياسة الإرجاع خلال 14 يوماً",
        "terms.physicalPolicy": "يُقبل الاسترداد للمنتجات المادية خلال 14 يوماً من تاريخ الشراء، فقط إذا كان المنتج معيباً أو لا يعمل بشكل صحيح.",
        "terms.physicalCondition": "يُقبل الاسترداد فقط إذا كان المنتج لا يعمل أو معيباً.",
        "terms.physicalWindow": "يجب تقديم طلب الإرجاع خلال 14 يوماً من تاريخ الشراء.",
        "terms.physicalShipping": "تكاليف شحن إعادة المنتج يدفعها المشتري.",
        "terms.physicalInspection": "سيتم فحص المنتج المرتجع قبل معالجة أي استرداد.",
        "terms.shippingNote": "رسوم شحن الإرجاع هي مسؤولية المشتري.",
        "terms.complaintsTitle": "٣- الشكاوى الكاذبة - إنهاء الحساب",
        "terms.complaintsPolicy": "لدى متجر VEEVAMMERCE سياسة عدم التسامح المطلق مع الشكاوى الاحتيالية أو الكاذبة. أي عميل يُكتشف تقديمه لمطالبات كاذبة سيتم حظر حسابه وحذفه نهائياً دون إشعار مسبق.",
        "terms.complaintsNote": "أي شكاوى كاذبة ستؤدي إلى حظر الحساب وحذفه نهائياً.",
        "terms.generalTitle": "شروط عامة",
        "terms.general1": "بإجراء عملية شراء في متجر VEEVAMMERCE، أنت توافق على هذه الشروط والسياسات.",
        "terms.general2": "يحتفظ متجر VEEVAMMERCE بالحق في تعديل هذه الشروط في أي وقت دون إشعار مسبق.",
        "terms.general3": "جميع الأسعار مدرجة بالدولار الأمريكي وقد تختلف حسب العملة المختارة.",
        "terms.general4": "متجر VEEVAMMERCE غير مسؤول عن تأخيرات الشحن التي تسببها شركات النقل.",
        "terms.lastUpdated": "آخر تحديث: فبراير 2026",

        "chat.title": "دعم VEEVAMMERCE",
        "chat.subtitle": "مساعد ذكي - متاح دائماً",
        "chat.welcome": "مرحباً! أهلاً بك في دعم VEEVAMMERCE. كيف يمكنني مساعدتك اليوم؟",
        "chat.placeholder": "اكتب رسالتك...",

        "lang.english": "الإنجليزية",
        "lang.arabic": "العربية",
        "lang.french": "الفرنسية",
        "lang.turkish": "التركية",
        "lang.german": "الألمانية",
        "lang.italian": "الإيطالية",
        "lang.chinese": "الصينية",
        "lang.hindi": "الهندية",
      }}
    },
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
